//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: max-content;
    & span {
        line-height: 20px;
        font-size: 12px;
        border-radius: 4px;
        padding: 0 8px;
        background-color: var(--purple-7);
        font-weight: bold;
    }
    &.primary {
        & span {
            background-color: var(--purple-7);
            color: var(--purple-2);
        }
    }
    &.secondary {
        & span {
            background-color: var(--green-4);
            color: var(--green-2);
        }
    }
`;